// extracted by mini-css-extract-plugin
export var content = "blog-module--content--sEZiY";
export var publishedOn = "blog-module--publishedOn--mH+5i";
export var tagsAndDate = "blog-module--tagsAndDate--K8baj";